export enum SignUpStepHeaderLocalizationId {
    DontHaveAnAccount = "sign-in.dont_have_an_account_paragraph",
    SignUpLink = "sign-in.sign_up_link",
}
